import * as jQuery from "jquery";
import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { Sounds } from "source/app/services/Sound/Sounds";

export function PlaySoundOnScrollingInBookOfMind(state: IBookOfMindState) {
    React.useEffect(() => {
        jQuery("#childContainer")
            .off("scroll")
            .on("scroll", () =>
                Sounds.paper_quick_flip.Play({ allowConcurrent: false })
            );
    }, [state.remainingQuotesToDisplay.length]);
}
